export const STRATEGICAL = 'Sanepar_Estrategicos';
export const GHID = 'Sanepar_GHID';
export const GGML = 'Sanepar_GGML';
export const GGND = 'Sanepar_GGND';
export const GGSD = 'Sanepar_GGSD';
export const GGNO = 'Sanepar_GGNO';
export const GGSO = 'Sanepar_GGSO';

const GGML_bbox = [ -50.2313,-26.2374,-48.0238,-24.4168 ];
const GGND_bbox = [ -52.0334,-24.4686,-49.5484,-22.5391 ];
const GGSD_bbox = [ -53.1521,-26.7163,-49.2008,-23.7939 ];
const GGNO_bbox = [ -54.1859, -24.9321, -51.5904, -22.5167 ];
const GGSO_bbox = [ -54.6193, -26.6001, -51.5111, -23.9812 ];

export const managementRoleBBOX = (roles) => {
    const managmentRoles = [GGML, GGND, GGSD, GGNO, GGSO];
    let bbox = undefined;

    const findRole = roles.find((role) => managmentRoles.includes(role));

    if(findRole){
        switch (findRole) {
            case GGML:
                bbox = GGML_bbox;
                break;
            case GGND:
                bbox = GGND_bbox;
                break;
            case GGSD:
                bbox = GGSD_bbox;
                break;
            case GGSO:
                bbox = GGSO_bbox;
                break;
            case GGNO:
                bbox = GGNO_bbox;
                break;
            default:
                break;
        }
    }

    return bbox;
}